import { render } from "./AddScoringRecordItemDialog.vue?vue&type=template&id=d355195a&scoped=true"
import script from "./AddScoringRecordItemDialog.vue?vue&type=script&lang=js"
export * from "./AddScoringRecordItemDialog.vue?vue&type=script&lang=js"

import "./AddScoringRecordItemDialog.vue?vue&type=style&index=0&id=d355195a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d355195a"

export default script